/**
 * @generated SignedSource<<fc541da3194f1de0d587fcf06f0a0616>>
 * @relayHash c2ea2aa7a71b5ac806587ff2d50a7bb5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5eea26e4b40186b9f6b3dfb462783692ab7f4d0868d03ef23a0dcb2146f8be77

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraJqlViewContext = "JPD_ROADMAPS" | "JSM_QUEUE_PAGE" | "JSM_SUMMARY_PAGE" | "JSW_PLANS" | "JSW_SUMMARY_PAGE" | "JWM" | "SHADOW_REQUEST" | "%future added value";
export type getPeoplePropsQuery$variables = {
  after?: string | null | undefined;
  cloudId: string;
  first?: number | null | undefined;
  includeAppTypeForJqlBuilder: boolean;
  jql: string;
  jqlTerm: string;
  searchString: string;
  viewContext?: JiraJqlViewContext | null | undefined;
};
export type getPeoplePropsQuery$data = {
  readonly jira: {
    readonly jqlBuilder: {
      readonly fieldValues: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly __typename: string;
            readonly displayName: string;
            readonly jqlTerm: string;
            readonly user?: {
              readonly appType?: string | null | undefined;
              readonly picture: AGG$URL;
            } | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
        readonly pageInfo: {
          readonly endCursor: string | null | undefined;
        };
        readonly totalCount: number | null | undefined;
      } | null | undefined;
    } | null | undefined;
  };
};
export type getPeoplePropsQuery = {
  response: getPeoplePropsQuery$data;
  variables: getPeoplePropsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": 10,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeAppTypeForJqlBuilder"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jql"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "jqlTerm"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchString"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewContext"
},
v8 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v9 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "jqlContext",
    "variableName": "jql"
  },
  {
    "kind": "Variable",
    "name": "jqlTerm",
    "variableName": "jqlTerm"
  },
  {
    "kind": "Variable",
    "name": "searchString",
    "variableName": "searchString"
  },
  {
    "kind": "Variable",
    "name": "viewContext",
    "variableName": "viewContext"
  }
],
v10 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v11 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v12 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v13 = {
  "kind": "ScalarField",
  "name": "jqlTerm"
},
v14 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v15 = {
  "kind": "ScalarField",
  "name": "picture"
},
v16 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "condition": "includeAppTypeForJqlBuilder",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "appType"
        }
      ]
    }
  ],
  "type": "AppUser"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "name": "getPeoplePropsQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v8/*: any*/),
              "concreteType": "JiraJqlBuilder",
              "kind": "LinkedField",
              "name": "jqlBuilder",
              "plural": false,
              "selections": [
                {
                  "args": (v9/*: any*/),
                  "concreteType": "JiraJqlFieldValueConnection",
                  "kind": "LinkedField",
                  "name": "fieldValues",
                  "plural": false,
                  "selections": [
                    (v10/*: any*/),
                    (v11/*: any*/),
                    {
                      "concreteType": "JiraJqlFieldValueEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v12/*: any*/),
                            (v13/*: any*/),
                            (v14/*: any*/),
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "kind": "LinkedField",
                                  "name": "user",
                                  "plural": false,
                                  "selections": [
                                    (v15/*: any*/),
                                    (v16/*: any*/)
                                  ]
                                }
                              ],
                              "type": "JiraJqlUserFieldValue"
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v0/*: any*/),
      (v7/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "getPeoplePropsQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v8/*: any*/),
            "concreteType": "JiraJqlBuilder",
            "kind": "LinkedField",
            "name": "jqlBuilder",
            "plural": false,
            "selections": [
              {
                "args": (v9/*: any*/),
                "concreteType": "JiraJqlFieldValueConnection",
                "kind": "LinkedField",
                "name": "fieldValues",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  (v11/*: any*/),
                  {
                    "concreteType": "JiraJqlFieldValueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "user",
                                "plural": false,
                                "selections": [
                                  (v12/*: any*/),
                                  (v15/*: any*/),
                                  (v16/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "id"
                                  }
                                ]
                              }
                            ],
                            "type": "JiraJqlUserFieldValue"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "5eea26e4b40186b9f6b3dfb462783692ab7f4d0868d03ef23a0dcb2146f8be77",
    "metadata": {},
    "name": "getPeoplePropsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "116dd317d7bb569e7325fd610597f784";

export default node;
